import { render } from "./HeaderMenu.vue?vue&type=template&id=4374d81c&ts=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=ts"
export * from "./HeaderMenu.vue?vue&type=script&lang=ts"

import "./HeaderMenu.vue?vue&type=style&index=0&id=4374d81c&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__